import type { TFunction } from 'i18next';

/** お問い合わせ種別 */
export const INQUIRY_TYPES = [
  'usage-question',
  'bug-report',
  'opinion',
  'data-format-request',
  'paid-plan-consultation',
  'other',
] as const;

export type InquiryType = (typeof INQUIRY_TYPES)[number];

/**
 * 種別の表示ラベルを取得する。
 *
 * 動的キー生成（`t(`inquiry.types.${type}`)`）は i18n-safety 規約で禁止されているため、
 * 明示的マッピングで全キーを参照する。
 */
export const getInquiryTypeLabel = (type: InquiryType, t: TFunction): string => {
  const labels: Record<InquiryType, string> = {
    'usage-question': t('inquiry.types.usage-question'),
    'bug-report': t('inquiry.types.bug-report'),
    opinion: t('inquiry.types.opinion'),
    'data-format-request': t('inquiry.types.data-format-request'),
    'paid-plan-consultation': t('inquiry.types.paid-plan-consultation'),
    other: t('inquiry.types.other'),
  };
  return labels[type];
};
